module.exports = {
	"header.logo.title": "GROHE Duş Yapılandırması",
	"homepage.headline": "GROHE Duş Sistemi Yapılandırması",
	"homepage.introtext": "İhtiyaçlarınıza uygun GROHE SmartControl duş sistemini yapılandırmak için lütfen aşağıdaki birkaç soruyu yanıtlayın.",
	"homepage.buttonStart": "Başla",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"footer.privacy.text": "Gizlilik",
	"footer.privacy.url": "https://www.grohe.com.tr/tr_tr/gizlilik.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.com.tr/tr_tr/bilgilendirme.html",
	"footer.copyright": "© 2018 GROME İÇ VE DIŞ TİC. A.Ş.",
	"configurator.button.seeResults": "Sonuçları gör",
	"question1.question": "Duşunuzu nerede kullanmak istiyorsunuz?",
	"question1.option1.text": "Duşta",
	"question1.option2.text": "Banyoda",
	"question2.question": "Ne tür bir kurulum tercih edersiniz? Duvar Üzeri mi, Yarı Ankastre mi yoksa Ankastre mi?",
	"question2.option1.text": "Duş ve termostat için duvar üzeri kurulum",
	"question2.option2.text": "Duvar Üzeri Termostat ile yarı ankastre duş kurulumu",
	"question2.option3.text": "Ankastre kurulum",
	"question3.question": "Duşunuzun nasıl çalışmasını istersiniz?",
	"question3.option1.text": "SmartControl çalışma şekli ve Termostat ile",
	"question3.option2.text": "SmartControl çalışma şekli ve Termostat ile",
	"question3.option3.text": "Geleneksel çalışma şekli ve termostat ile",
	"question3.option4.text": "Geleneksel çalışma şekli ve termostat ile",
	"question3.option5.text": "Tek kumandalı batarya ile",
	"question3.option6.text": "Tek kumandalı batarya ile",
	"question3.option7.text": "Yön değiştirici sistem ile (mevcut armatür değiştirilmeden)",
	"question4.question": "Duşunuz ile neleri kontrol etmek istersiniz?",
	"question4.option1.text": "Yalnızca el duşu",
	"question4.option2.text": "Büyük bir tepe duşu (150-250 mm) ve el duşu",
	"question4.option3.text": "Büyük bir tepe duşu (150-250 mm) ve el duşu",
	"question4.option4.text": "Büyük bir tepe duşu (150-250 mm) ve el duşu",
	"question4.option5.text": "Büyük bir tepe duşu (150-250 mm) ve el duşu",
	"question4.option6.text": "Çok büyük bir tepe duşu (250-400 mm) ve el duşu",
	"question4.option7.text": "Çok büyük bir tepe duşu (250-400 mm) ve el duşu",
	"question4.option8.text": "Çok büyük bir tepe duşu (250-400 mm) ve el duşu",
	"question4.option9.text": "Çok büyük bir tepe duşu (250-400 mm) ve el duşu",
	"question4.option10.text": "Büyük bir tepe duşu (150-250 mm), el duşu ve banyo çıkış ucu",
	"question4.option11.text": "Çok büyük bir tepe duşu (250-400 mm), el duşu ve banyo çıkış ucu",
	"question5.question": "Hangi şekli tercih edersiniz?",
	"question5.option1.text": "Kare",
	"question5.option2.text": "Yuvarlak",
	"question6.question": "Kaç adet su çıkışına ihtiyaç duyuyorsunuz?",
	"question6.option1.text": "Üç: 2 akış modelli tepe duşu ve el duşu",
	"question6.option2.text": "Üç: 2 akış modelli tepe duşu ve el duşu",
	"question6.option3.text": "Üç: Tepe duşu, el duşu ve banyo çıkış ucu",
	"question6.option4.text": "Üç: Tepe duşu, yan duş ve el duşu",
	"question6.option5.text": "İki: Tepe duşu ve el duşu",
	"question6.option6.text": "İki: El duşu ve banyo çıkış ucu",
	"question6.option7.text": "Bir: Sadece el duşu",
	"question6.option8.text": "Bir: Banyo çıkış ucu",
	"question7.question": "Renginizi seçin",
	"question7.option1.text": "Krom",
	"question7.option2.text": "Beyaz/Krom",
	"question7.option3.text": "Beyaz",
	"question8.question": "Dış gövde içinde entegre bir duş askısı bulunmasını ister miydiniz?",
	"question8.option1.text": "Evet, entegre duş askısı bulunmasını isterim",
	"question8.option2.text": "Hayır, el duşu askısını ayrı olarak satın alacağım",
	"question9.question": "El duşu için duş sürgüsü barı mı yoksa duş askısı barı mı tercih edersiniz?",
	"question9.option1.text": "Duş sürgüsü barı",
	"question9.option2.text": "Duş askısı barı",
	"question10.question": "Tepe duşunun duvara mı yoksa tavana mı monte edilmesini tercih edersiniz?",
	"question10.option1.text": "Duvara monte edilmiş tepe duşu",
	"question10.option2.text": "Tavana monte edilmiş tepe duşu",
	"results.title": "{productGroupsCount, plural, \none {Sonucunuz} \nother {Sonuçlarınız}\n}",
	"results.bundle.title": "Doğru kurulum için ayrıca şunlar gerekmektedir:",
	"results.newConfiguration.buttonText": "Yeni yapılandırma başlat",
	"results.product.button.productInformation": "Ürün bilgisi",
	"results.product.button.dealerLocator": "Showroom bul",
	"results.product.button.buyNow": "Online Satın Al",
	"results.product.information": "Ürün bilgisi",
	"results.product.dealer": "Showroom bul",
	"results.proposal.title": "Teklif {number}",
	"results.proposal.title.single": "Teklif",
	"results.newConfiguration.title": "Yeni bir duş sistemi yapılandırmak ister misiniz?",
	"results.product.number": "Ürün Kodu: #{number}",
	"results.product.button.downloadPDF": "Teklifi indir (PDF)",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"404.title": "404 Sayfa bulunamadı",
	"404.link.goBack": "Ana sayfaya geri dön"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.tr_tr.json
// module id = 766
// module chunks = 0